import { getMachinesSearchRegionListOptions } from "@aura-frontend/omnibus-az-client";
import { useQuery } from "@tanstack/react-query";

export type UseRegionsParams = {
  enabled?: boolean;
};

export const useRegions = ({ enabled = true }: UseRegionsParams = {}) => {
  const {
    data: regionsResponse,
    isLoading: loadingRegions,
    error: regionError,
  } = useQuery({
    ...getMachinesSearchRegionListOptions({}),
    enabled,
  });

  return {
    regions: regionsResponse?.regions.sort() ?? [],
    loadingRegions,
    regionError,
  };
};
